<script setup>
    import {
        Head
    } from '@vueuse/head'
</script>
<template>

    <Head>
        <title>{{ title }}</title>
        <meta name="description" :content="description">

        <!-- Social -->
        <meta property="og:title" :content="title">
        <meta property="og:description" :content="description">
        <!-- <meta property="og:image" content="https://picsum.photos/1200/675"> -->

        <!-- Twitter -->
        <meta name="twitter:title" :content="title">
        <meta name="twitter:description" :content="description">
        <!-- <meta name="twitter:image" content="https://picsum.photos/1200/675"> -->
        <!-- <meta name="twitter:card" content="summary_large_image"> -->
    </Head>
    <section class="py-10">
        <div class="container mt-5 mt-lg-10 text-white">
            <BreadcrumbsVue>
                <template v-slot:title>
                    Works
                </template>
                <template v-slot:title-link>
                    Works
                </template>
            </BreadcrumbsVue>
            <div class="row g-1 g-lg-2 align-items-center justify-content-between mt-5">
                <p class="mb-5">These are some things I work on, some things I participate in, and some things I enjoy.</p>
                <div v-for="( work , i) in works" :key="i" class="col-md-6 col-lg-4 mb-5 aos-init aos-animate"
                    data-aos="fade-up" data-aos-delay="150">
                    <router-link :to="{name : 'slug' , params: {slug: work.slug}}">
                        <div class="card">
                            <div class="equal-1-1 mb-2">
                                <figure class="background" :style="`background-image: url('${work.thumbnail}')`">
                                </figure>
                            </div>
                            <h4 class="card-title text-white fw-bold">{{ work.title }}</h4>
                            <span class="text-secondary"  v-for="(tag, i ) in work.tags" :key="i">{{ tag.tag }}</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import BreadcrumbsVue from "../components/Breadcrumbs.vue"
    //   import WorkCardVue from "../components/WorkCard.vue"
    import works from '../../data/works_original.json';
    export default {
        components: {
            BreadcrumbsVue,
            //  WorkCardVue
        },
        data: () => ({
            works,
             title : "Work | Jethro Jorolan",
            description: "These are some things I work on, some things I participate in, and some things I enjoy."
        }),
    }
</script>
